import {Validators} from '@angular/forms';
import {FormAction, VisaFN, VisaFormConfig, VisaFormName} from 'src/app/shared/models/forms';
import { UserPlatformRole } from '../user';

//Model to represent the resident permit form config
export const RES_FORM_FIRST_CONFIG: VisaFormConfig = {
  [VisaFormName.PERSONAL_DETAILS]: {
    version: 0.1,
    classNames: 'gap_25',
    fields: [
      {name: VisaFN.NATIONALITY, type: 'select', icon: 'globe', validators: [], showInResume: true},
      {name: VisaFN.REGISTRATION_PORT_ID, type: 'select', icon: 'globe', validators: [], showInResume: true},
      {name: VisaFN.LAST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.FIRST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.MAIDEN_NAME, type: 'text', icon: 'person', validators: [], showInResume: true, requiredIfFormControl: false, ifFormControlHasValue: {control: VisaFN.GENDER, value: 'female'}},
      {name: VisaFN.GENDER, type: 'select', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.MARITAL_STATUS, type: 'select', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.BIRTH_DAY, type: 'date', icon: 'cake-candles', validators: [], showInResume: true},
      {name: VisaFN.BIRTH_CITY, type: 'text', icon: 'location-dot', validators: [], showInResume: true},
      {name: VisaFN.BIRTH_COUNTRY, type: 'select', icon: 'globe', validators: [], showInResume: true},
      {name: VisaFN.HEIGHT, type: 'number', icon: 'ruler', validators: [], showInResume: true},
      {name: VisaFN.HAIR_COLOR, type: 'select', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.EYE_COLOR, type: 'select', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.OCCUPATION, type: 'text', icon: 'briefcase', validators: [], showInResume: true},
      {name: VisaFN.MOTHERS_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.FATHERS_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.REQUEST_REASON, type: 'select', icon: 'person', validators: [], showInResume: true}
    ]
  },
  [VisaFormName.CONTACT_DETAILS]: {
    version: 0.1,
    classNames: 'gap_25',
    fields: [
      {name: VisaFN.ADDRESS_LINE_1, type: 'text', icon: 'location-dot', validators: [], showInResume: true},
      {name: VisaFN.ADDRESS_LINE_2, type: 'text', icon: 'location-dot', validators: [], showInResume: true},
      {name: VisaFN.ADDRESS_LINE_3, type: 'text', icon: 'location-dot', validators: [], showInResume: true},
      {name: VisaFN.INDICATIVE_PHONE, type: 'text', validators: [Validators.required], pattern: '^(?:\\+[1-9]\\d{0,3})$', showInResume: true, value: '+269', sameRow: 'phone-row', customClass: 'w-20'},
      {name: VisaFN.PHONE_LOCAL, type: 'text', icon: 'phone', validators: [Validators.required], pattern: '^\\d{6,11}$', showInResume: true, sameRow: 'phone-row', customClass: 'w-80'}
    ]
  },
  [VisaFormName.DOCUMENT]: {
    version: 0.1,
    classNames: 'gap_10',
    disabledForSeniorities: [1],
    disabledForRoles: [UserPlatformRole.CUSTOMER, UserPlatformRole.WORKER],
    fields: [
      {name: VisaFN.PASSPORT_SCAN, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.WORK_CONTRACT, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.EMPLOYER_COMMITMENT_FORM, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.RESIDENCE_CERTIFICATE, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.LOSS_DECLARATION, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.IDENTITY_PHOTO, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE}
    ]
  }
};
